import styled from 'styled-components';

import { HOME } from '../../../../theme/tokens';
import { Text } from '../../../../components';

export const Root = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const Label = styled(Text)`
  font-size: 16px;
  font-weight: 400;
  color: ${HOME.t300};
`;

export const Value = styled.div<{ $compact: boolean }>`
  font-size: 24px;
  font-weight: 700;
  color: ${HOME.t50};
  /* Bare split stats sit 6px under the label (source SplitStat); the acquisition
     stat with its inline delta uses the default 8px. */
  margin-top: ${(p) => (p.$compact ? '6px' : '8px')};
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  row-gap: 4px;
`;

export const Cap = styled(Text)`
  font-size: 12px;
  font-weight: 300;
  color: ${HOME.t500};
  margin-top: 6px;
  white-space: nowrap;
`;
